import axios from 'axios';
import { handleSuccess, handleError } from './axiosHandler';
import { authHeader } from '../_helpers/auth-header';

import  config  from '../config';
const base_url = config.apiUrl;

export const userService = {
    login,
    logout,
    register,
    getAll,
    getRoles,
    getUserRoles,
    getById,
    update,
    add,
    edit,
    delete: _delete
};

function login(username, password) {

    const url = base_url + 'auth';

    return axios.post(url, { username: username, password: password }, { headers: { 'Content-Type': 'application/json' } })
        .then(function (response) {
            localStorage.setItem('user', JSON.stringify(response.data));
            return response.data;
        })
        .catch(function (error) {
            handleError(error)
        });
}

function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('user');
    localStorage.removeItem('token');
}

function getAll() {
    const url =  base_url + 'Users';
    axios.interceptors.response.use(handleSuccess, handleError);
    return axios.get(url, { headers: authHeader() });
}

function getRoles() {
    const url = `api/Roles`;
    axios.interceptors.response.use(handleSuccess, handleError);
    return axios.get(url, { headers: authHeader() });
}

function getUserRoles(id) {
    const url = `api/UserRoles/` + id;
    axios.interceptors.response.use(handleSuccess, handleError);
    return axios.get(url, { headers: authHeader() });
}

function add(form) {
    const url = 'api/Users';
    axios.interceptors.response.use(handleSuccess, handleError);
    return axios.post(url, form, { headers: authHeader() });
}

function edit(id, form) {
    const url = 'api/Users/' + id;
    axios.interceptors.response.use(handleSuccess, handleError);
    return axios.put(url, form, { headers: authHeader() });
}

function _delete(id) {
    const url = 'api/Users/' + id;
    axios.interceptors.response.use(handleSuccess, handleError);
    return axios.delete(url, { headers: authHeader() });
}


function getById(id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(`api/users/${id}`, requestOptions).then(handleResponse);
}

function register(user) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(user)
    };

    return fetch(`api/users/register`, requestOptions).then(handleResponse);
}

function update(user) {
    const requestOptions = {
        method: 'PUT',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(user)
    };

    return fetch(`api/users/${user.id}`, requestOptions).then(handleResponse);
}


function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                //location.reload(true);
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}
